import React from 'react';
import Link from 'next/link';

import twMerge from 'utilities/src/twMerge';

/**
 * Widget Links Props
 */

type WidgetLinksProps = {
  links: {
    label: string;
    href: string;
  }[];
  separator?: boolean;
};

/**
 * Widget Links Component
 */

export default function WidgetLinks({ links, separator = true }: WidgetLinksProps) {
  return (
    <div className={twMerge('flex flex-col px-4', separator && 'pb-2 pt-1', !separator && 'gap-4 pb-4 pt-3')}>
      {links.map((link) => (
        <div
          key={link.label}
          className={twMerge(separator && 'border-site-neutrals-50 border-b py-3 last:border-b-0')}
        >
          <Link href={link.href} key={link.label}>
            <span className="site-paragraph-m text-site-neutrals-600 hover:text-site-neutrals-900 font-normal underline">
              {link.label}
            </span>
          </Link>
        </div>
      ))}
    </div>
  );
}
